import { render } from "./CatalogCard.vue?vue&type=template&id=4c28d758&scoped=true"
import script from "./CatalogCard.vue?vue&type=script&lang=js"
export * from "./CatalogCard.vue?vue&type=script&lang=js"

import "./CatalogCard.vue?vue&type=style&index=0&id=4c28d758&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c28d758"]])

export default __exports__